import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Accordion, Button } from "react-bootstrap";

// css
import styles from "./Sidebar.module.scss";
import GannWheel from "./GannWheel";
import Wheels from "./Wheels";
import Overlays from "./Overlays";

// img
import logo from "../../Assets/images/logo.png";
import cross from "../../Assets/svg/cross.svg";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/login";
import useCheckPermission from "../../hooks/useCheckPermission";

const Sidebar = ({ sidebar }) => {
  const [step, setStep] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()

  const pageActive = location.pathname.replace(/^\/+/, "");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div
      className={`${styles.sidebar} ${sidebar && styles.active} ${sidebar && "active"
        } sidebar p-3 mob-sidebar`}
    >

      <img src={cross} alt="cross" className="img-fluid cross-sidebar" width={30} height={30} />

      <div className="logo py-3 mb-2 text-center">
        <img src={logo} alt="" className="img-fluid" />
      </div>

      {["wheels", "overlays"].includes(step) && (
        <>
          <div
            className={`${styles.linksWrpper} position-relative linksWrpper flex flex-column justify-content-between align-items-center d-flex`}
          >
            <div className="top w-100">
              <div className="py-2">
                <h6 className="m-0 pb-2">
                  <Button
                    onClick={() => setStep("")}
                    className="border-0 p-0 bg-transparent text-dark position-absolute "
                    style={{ top: "0", left: 0 }}
                  >
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_3_10)">
                          <path
                            d="M3.5269 6.8117C4.01548 5.98632 4.76176 5.34438 5.65088 4.98465C6.54001 4.62493 7.52271 4.56735 8.44776 4.82079C9.37281 5.07423 10.1889 5.62463 10.7706 6.3873C11.3522 7.14997 11.6671 8.08264 11.6667 9.04178C11.6667 9.19649 11.7282 9.34486 11.8376 9.45426C11.947 9.56365 12.0954 9.62511 12.2501 9.62511C12.4048 9.62511 12.5532 9.56365 12.6625 9.45426C12.7719 9.34486 12.8334 9.19649 12.8334 9.04178C12.8335 7.86854 12.4612 6.72555 11.7702 5.77741C11.0791 4.82927 10.105 4.12492 8.98809 3.76578C7.87117 3.40664 6.66909 3.41125 5.55496 3.77894C4.44083 4.14664 3.47214 4.85845 2.7884 5.81186L2.47515 4.03561C2.44831 3.88322 2.36203 3.74774 2.2353 3.65896C2.10856 3.57019 1.95175 3.5354 1.79936 3.56224C1.64697 3.58908 1.51149 3.67536 1.42271 3.80209C1.33394 3.92883 1.29914 4.08564 1.32599 4.23803L1.93382 7.68495C1.96087 7.83727 2.04732 7.97261 2.17415 8.0612C2.25681 8.11662 2.35122 8.15206 2.44993 8.16472C2.54864 8.17737 2.64894 8.1669 2.7429 8.13411L6.05624 7.5502C6.20863 7.52335 6.34411 7.43707 6.43288 7.31034C6.52166 7.1836 6.55645 7.02679 6.52961 6.8744C6.50277 6.72202 6.41649 6.58653 6.28975 6.49776C6.16302 6.40898 6.00621 6.37419 5.85382 6.40103L3.5269 6.8117Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3_10">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span className="text-capitalize">{step}</span>
                  </Button>
                </h6>

                <div className="py-2 h-100">
                  {step === "wheels" && <Wheels />}
                  {step === "overlays" && <Overlays />}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {!step && (
        <>
          <Accordion
            // activeKey={pageActive === "gann-wheel" ? "gann-properties" : ""}
            className={`${styles.linksWrpper} position-relative linksWrpper flex flex-column justify-content-between align-items-center d-flex`}
          >
            <div className="top w-100">
              <div className="py-2">
                <h6 className="m-0 pb-2">Main Menu</h6>

                <ul className="list-unstyled ps-0 mb-0">
                  {useCheckPermission("dashboard", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/dashboard"
                      className={`${styles.navLink} ${pageActive === "dashboard" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "dashboard" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.0567 1.5H14.5962C15.6479 1.5 16.5001 2.35939 16.5001 3.41997V5.98089C16.5001 7.04148 15.6479 7.90087 14.5962 7.90087H12.0567C11.005 7.90087 10.1528 7.04148 10.1528 5.98089V3.41997C10.1528 2.35939 11.005 1.5 12.0567 1.5Z"
                              fill="url(#paint0_linear_0_982)"
                            />

                            <path
                              d="M5.94337 10.0991C6.99507 10.0991 7.84726 10.9585 7.84726 12.0191V14.58C7.84726 15.6399 6.99507 16.5 5.94337 16.5H3.40389C2.35219 16.5 1.5 15.6399 1.5 14.58V12.0191C1.5 10.9585 2.35219 10.0991 3.40389 10.0991H5.94337ZM14.5961 10.0991C15.6478 10.0991 16.5 10.9585 16.5 12.0191V14.58C16.5 15.6399 15.6478 16.5 14.5961 16.5H12.0566C11.0049 16.5 10.1527 15.6399 10.1527 14.58V12.0191C10.1527 10.9585 11.0049 10.0991 12.0566 10.0991H14.5961ZM5.94337 1.5C6.99507 1.5 7.84726 2.35939 7.84726 3.41997V5.98089C7.84726 7.04148 6.99507 7.90087 5.94337 7.90087H3.40389C2.35219 7.90087 1.5 7.04148 1.5 5.98089V3.41997C1.5 2.35939 2.35219 1.5 3.40389 1.5H5.94337Z"
                              fill="url(#paint1_linear_0_982)"
                            />

                            <defs>
                              <linearGradient
                                id="paint0_linear_0_982"
                                x1="13.3265"
                                y1="1.5"
                                x2="13.3265"
                                y2="7.90087"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />

                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>

                              <linearGradient
                                id="paint1_linear_0_982"
                                x1="9"
                                y1="1.5"
                                x2="9"
                                y2="16.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />

                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.0567 1.5H14.5962C15.6479 1.5 16.5001 2.35939 16.5001 3.41997V5.98089C16.5001 7.04148 15.6479 7.90087 14.5962 7.90087H12.0567C11.005 7.90087 10.1528 7.04148 10.1528 5.98089V3.41997C10.1528 2.35939 11.005 1.5 12.0567 1.5Z"
                              fill="#7D96B3"
                            />

                            <path
                              d="M5.94337 10.0991C6.99507 10.0991 7.84726 10.9585 7.84726 12.0191V14.58C7.84726 15.6399 6.99507 16.5 5.94337 16.5H3.40389C2.35219 16.5 1.5 15.6399 1.5 14.58V12.0191C1.5 10.9585 2.35219 10.0991 3.40389 10.0991H5.94337ZM14.5961 10.0991C15.6478 10.0991 16.5 10.9585 16.5 12.0191V14.58C16.5 15.6399 15.6478 16.5 14.5961 16.5H12.0566C11.0049 16.5 10.1527 15.6399 10.1527 14.58V12.0191C10.1527 10.9585 11.0049 10.0991 12.0566 10.0991H14.5961ZM5.94337 1.5C6.99507 1.5 7.84726 2.35939 7.84726 3.41997V5.98089C7.84726 7.04148 6.99507 7.90087 5.94337 7.90087H3.40389C2.35219 7.90087 1.5 7.04148 1.5 5.98089V3.41997C1.5 2.35939 2.35219 1.5 3.40389 1.5H5.94337Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Dashboard
                    </NavLink>
                  </li>}

                  {useCheckPermission("gennWheel", "VIEW") && <GannWheel
                    step={step}
                    setStep={setStep}
                    pageActive={pageActive}
                  />}
                  {useCheckPermission("helioconfig", "VIEW") && <li className="py-1">
                    <NavLink to="/helioconfig"
                      className={`${styles.navLink} ${pageActive === "helioconfig" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}><span className="icn me-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings-icon lucide-settings">
                          <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"/><circle cx="12" cy="12" r="3"/></svg>
                        </span>HelioCentric Config</NavLink>
                  </li>}

                </ul>
              </div>

              <div className="py-2">
                <h6 className="m-0 pb-2">Other Options</h6>

                <ul className="list-unstyled ps-0 mb-0">
                  {useCheckPermission("user", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/customer"
                      className={`${styles.navLink} ${pageActive === "customer" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "customer" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.99751 11.3809C5.76276 11.3809 2.99976 11.8909 2.99976 13.9309C2.99976 15.9716 5.74551 16.4996 8.99751 16.4996C12.2323 16.4996 14.9953 15.9904 14.9953 13.9496C14.9953 11.9089 12.2503 11.3809 8.99751 11.3809Z"
                              fill="url(#paint0_linear_0_1878)"
                            />
                            <path
                              opacity="0.4"
                              d="M8.99756 9.43776C11.2011 9.43776 12.9666 7.67151 12.9666 5.46876C12.9666 3.26601 11.2011 1.49976 8.99756 1.49976C6.79481 1.49976 5.02856 3.26601 5.02856 5.46876C5.02856 7.67151 6.79481 9.43776 8.99756 9.43776Z"
                              fill="url(#paint1_linear_0_1878)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_1878"
                                x1="8.99751"
                                y1="11.3809"
                                x2="8.99751"
                                y2="16.4996"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_1878"
                                x1="8.99756"
                                y1="1.49976"
                                x2="8.99756"
                                y2="9.43776"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.99751 11.3809C5.76276 11.3809 2.99976 11.8909 2.99976 13.9309C2.99976 15.9716 5.74551 16.4996 8.99751 16.4996C12.2323 16.4996 14.9953 15.9904 14.9953 13.9496C14.9953 11.9089 12.2503 11.3809 8.99751 11.3809Z"
                              fill="#7D96B3"
                            />
                            <path
                              opacity="0.4"
                              d="M8.99756 9.43776C11.2011 9.43776 12.9666 7.67151 12.9666 5.46876C12.9666 3.26601 11.2011 1.49976 8.99756 1.49976C6.79481 1.49976 5.02856 3.26601 5.02856 5.46876C5.02856 7.67151 6.79481 9.43776 8.99756 9.43776Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Customers
                    </NavLink>
                  </li>
                  }
                  {useCheckPermission("home", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/homepage"
                      className={`${styles.navLink} ${pageActive === "homepage" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "homepage" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.99751 11.3809C5.76276 11.3809 2.99976 11.8909 2.99976 13.9309C2.99976 15.9716 5.74551 16.4996 8.99751 16.4996C12.2323 16.4996 14.9953 15.9904 14.9953 13.9496C14.9953 11.9089 12.2503 11.3809 8.99751 11.3809Z"
                              fill="url(#paint0_linear_0_1878)"
                            />
                            <path
                              opacity="0.4"
                              d="M8.99756 9.43776C11.2011 9.43776 12.9666 7.67151 12.9666 5.46876C12.9666 3.26601 11.2011 1.49976 8.99756 1.49976C6.79481 1.49976 5.02856 3.26601 5.02856 5.46876C5.02856 7.67151 6.79481 9.43776 8.99756 9.43776Z"
                              fill="url(#paint1_linear_0_1878)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_1878"
                                x1="8.99751"
                                y1="11.3809"
                                x2="8.99751"
                                y2="16.4996"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_1878"
                                x1="8.99756"
                                y1="1.49976"
                                x2="8.99756"
                                y2="9.43776"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.99751 11.3809C5.76276 11.3809 2.99976 11.8909 2.99976 13.9309C2.99976 15.9716 5.74551 16.4996 8.99751 16.4996C12.2323 16.4996 14.9953 15.9904 14.9953 13.9496C14.9953 11.9089 12.2503 11.3809 8.99751 11.3809Z"
                              fill="#7D96B3"
                            />
                            <path
                              opacity="0.4"
                              d="M8.99756 9.43776C11.2011 9.43776 12.9666 7.67151 12.9666 5.46876C12.9666 3.26601 11.2011 1.49976 8.99756 1.49976C6.79481 1.49976 5.02856 3.26601 5.02856 5.46876C5.02856 7.67151 6.79481 9.43776 8.99756 9.43776Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Homepage
                    </NavLink>
                  </li>}

                  {useCheckPermission("subscription", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/subscription"
                      className={`${styles.navLink} ${pageActive === "subscription" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "subscription" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M8.99338 13.966L4.12459 16.398C3.75691 16.5976 3.29826 16.4643 3.09261 16.0981C3.03255 15.983 3.00079 15.8551 3 15.725V10.2815C3 10.8212 3.3043 11.1543 4.10474 11.5274L8.99338 13.966Z"
                              fill="url(#paint0_linear_0_3616)"
                            />
                            <path
                              d="M11.3021 1.5C13.333 1.5 14.9802 2.29954 15 4.34503V15.7251C14.9992 15.8531 14.9674 15.9788 14.9074 16.0916C14.811 16.2755 14.6445 16.412 14.4461 16.4698C14.2477 16.5276 14.0346 16.5017 13.8556 16.3981L8.99338 13.9661L4.10474 11.5276C3.3043 11.1544 3 10.8213 3 10.2816V4.34503C3 2.29954 4.64719 1.5 6.67144 1.5H11.3021ZM11.8115 6.03072H6.16869C5.84353 6.03072 5.57993 6.29621 5.57993 6.62371C5.57993 6.95121 5.84353 7.2167 6.16869 7.2167H11.8115C12.1366 7.2167 12.4002 6.95121 12.4002 6.62371C12.4002 6.29621 12.1366 6.03072 11.8115 6.03072Z"
                              fill="url(#paint1_linear_0_3616)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_3616"
                                x1="5.99669"
                                y1="10.2815"
                                x2="5.99669"
                                y2="16.4906"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_3616"
                                x1="9"
                                y1="1.5"
                                x2="9"
                                y2="16.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M8.99338 13.9663L4.12459 16.3982C3.75691 16.5978 3.29826 16.4645 3.09261 16.0984C3.03255 15.9833 3.00079 15.8553 3 15.7253V10.2817C3 10.8214 3.3043 11.1546 4.10474 11.5277L8.99338 13.9663Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M11.3021 1.5C13.333 1.5 14.9802 2.29954 15 4.34503V15.7251C14.9992 15.8531 14.9674 15.9788 14.9074 16.0916C14.811 16.2755 14.6445 16.412 14.4461 16.4698C14.2477 16.5276 14.0346 16.5017 13.8556 16.3981L8.99338 13.9661L4.10474 11.5276C3.3043 11.1544 3 10.8213 3 10.2816V4.34503C3 2.29954 4.64719 1.5 6.67144 1.5H11.3021ZM11.8115 6.03072H6.16869C5.84353 6.03072 5.57993 6.29621 5.57993 6.62371C5.57993 6.95121 5.84353 7.2167 6.16869 7.2167H11.8115C12.1366 7.2167 12.4002 6.95121 12.4002 6.62371C12.4002 6.29621 12.1366 6.03072 11.8115 6.03072Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Subscription
                    </NavLink>
                  </li>}

                  {useCheckPermission("marketStock", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/stock-exchange"
                      className={`${styles.navLink} ${pageActive === "stock-exchange" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "stock-exchange" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.5067 1.5H5.5C2.94667 1.5 1.5 2.94667 1.5 5.5V12.5C1.5 15.0533 2.94667 16.5 5.5 16.5H12.5067C15.06 16.5 16.5 15.0533 16.5 12.5V5.5C16.5 2.94667 15.06 1.5 12.5067 1.5Z"
                              fill="url(#paint0_linear_0_5114)"
                            />
                            <path
                              d="M5.52649 7.02673C5.18649 7.02673 4.90649 7.30673 4.90649 7.6534V12.8067C4.90649 13.1467 5.18649 13.4267 5.52649 13.4267C5.87316 13.4267 6.15316 13.1467 6.15316 12.8067V7.6534C6.15316 7.30673 5.87316 7.02673 5.52649 7.02673Z"
                              fill="url(#paint1_linear_0_5114)"
                            />
                            <path
                              d="M9.02649 4.56674C8.68649 4.56674 8.40649 4.84674 8.40649 5.19341V12.8067C8.40649 13.1467 8.68649 13.4267 9.02649 13.4267C9.37316 13.4267 9.65316 13.1467 9.65316 12.8067V5.19341C9.65316 4.84674 9.37316 4.56674 9.02649 4.56674Z"
                              fill="url(#paint2_linear_0_5114)"
                            />
                            <path
                              d="M12.4799 9.74673C12.1333 9.74673 11.8533 10.0267 11.8533 10.3734V12.8067C11.8533 13.1467 12.1333 13.4267 12.4733 13.4267C12.8199 13.4267 13.0999 13.1467 13.0999 12.8067V10.3734C13.0999 10.0267 12.8199 9.74673 12.4799 9.74673Z"
                              fill="url(#paint3_linear_0_5114)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_5114"
                                x1="9"
                                y1="1.5"
                                x2="9"
                                y2="16.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_5114"
                                x1="5.52983"
                                y1="7.02673"
                                x2="5.52983"
                                y2="13.4267"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint2_linear_0_5114"
                                x1="9.02983"
                                y1="4.56674"
                                x2="9.02983"
                                y2="13.4267"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint3_linear_0_5114"
                                x1="12.4766"
                                y1="9.74673"
                                x2="12.4766"
                                y2="13.4267"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M11.5067 0.5H4.5C1.94667 0.5 0.5 1.94667 0.5 4.5V11.5C0.5 14.0533 1.94667 15.5 4.5 15.5H11.5067C14.06 15.5 15.5 14.0533 15.5 11.5V4.5C15.5 1.94667 14.06 0.5 11.5067 0.5Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M4.52649 6.02673C4.18649 6.02673 3.90649 6.30673 3.90649 6.6534V11.8067C3.90649 12.1467 4.18649 12.4267 4.52649 12.4267C4.87316 12.4267 5.15316 12.1467 5.15316 11.8067V6.6534C5.15316 6.30673 4.87316 6.02673 4.52649 6.02673Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M7.62 4C7.28 4 7 4.28 7 4.62667V12.24C7 12.58 7.28 12.86 7.62 12.86C7.96667 12.86 8.24667 12.58 8.24667 12.24V4.62667C8.24667 4.28 7.96667 4 7.62 4Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M11.4799 8.7467C11.1333 8.7467 10.8533 9.0267 10.8533 9.37337V11.8067C10.8533 12.1467 11.1333 12.4267 11.4733 12.4267C11.8199 12.4267 12.0999 12.1467 12.0999 11.8067V9.37337C12.0999 9.0267 11.8199 8.7467 11.4799 8.7467Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Markets Stock Listing
                    </NavLink>
                  </li>}

                  {useCheckPermission("masterPlanet", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/master-planet"
                      className={`${styles.navLink} ${pageActive === "master-planet" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "master-planet" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M15.5 7.99994C15.5 12.1422 12.1423 15.4999 8 15.4999C3.85775 15.4999 0.5 12.1422 0.5 7.99994C0.5 3.85844 3.85775 0.499939 8 0.499939C12.1423 0.499939 15.5 3.85844 15.5 7.99994Z"
                              fill="url(#paint0_linear_0_6647)"
                            />
                            <path
                              d="M10.895 5.52867L9.68003 9.36867C9.63503 9.52617 9.50753 9.65367 9.35003 9.69942L5.52503 10.8987C5.27003 10.9819 5.02253 10.7337 5.10503 10.4787L6.30503 6.63117C6.35003 6.47367 6.47753 6.35367 6.63503 6.30117L10.475 5.10117C10.7375 5.01867 10.9775 5.26617 10.895 5.52867Z"
                              fill="url(#paint1_linear_0_6647)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_6647"
                                x1="8"
                                y1="0.499939"
                                x2="8"
                                y2="15.4999"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_6647"
                                x1="8.00021"
                                y1="5.08502"
                                x2="8.00021"
                                y2="10.9151"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M15.5 7.99994C15.5 12.1422 12.1423 15.4999 8 15.4999C3.85775 15.4999 0.5 12.1422 0.5 7.99994C0.5 3.85844 3.85775 0.499939 8 0.499939C12.1423 0.499939 15.5 3.85844 15.5 7.99994Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M10.895 5.5287L9.68003 9.3687C9.63503 9.5262 9.50753 9.6537 9.35003 9.69945L5.52503 10.8987C5.27003 10.9819 5.02253 10.7337 5.10503 10.4787L6.30503 6.6312C6.35003 6.4737 6.47753 6.3537 6.63503 6.3012L10.475 5.1012C10.7375 5.0187 10.9775 5.2662 10.895 5.5287Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Master Planet
                    </NavLink>
                  </li>}

                  {useCheckPermission("secondaryPlanet", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/secondary-planet"
                      className={`${styles.navLink} ${pageActive === "secondary-planet" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "secondary-planet" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M9.73223 2.33521L11.4021 5.69092C11.5251 5.93404 11.7599 6.10288 12.0307 6.1404L15.7815 6.68667C16.0006 6.71744 16.1994 6.833 16.3336 7.00934C16.4664 7.18343 16.5234 7.40404 16.4912 7.6209C16.4649 7.80099 16.3802 7.96757 16.2504 8.09514L13.5325 10.7297C13.3337 10.9136 13.2437 11.186 13.2917 11.4523L13.9609 15.1562C14.0321 15.6035 13.7358 16.0252 13.2917 16.11C13.1087 16.1392 12.9212 16.1085 12.7561 16.0244L9.41041 14.2813C9.1621 14.156 8.86879 14.156 8.62049 14.2813L5.27477 16.0244C4.86368 16.2428 4.35432 16.0942 4.12552 15.689C4.04075 15.5277 4.01075 15.3438 4.0385 15.1645L4.70765 11.4599C4.75566 11.1942 4.66489 10.9203 4.46685 10.7365L1.74901 8.10339C1.42569 7.79123 1.41594 7.27722 1.72726 6.95381C1.73401 6.94706 1.74151 6.93955 1.74901 6.93205C1.87804 6.80073 2.04758 6.71744 2.23062 6.69568L5.98142 6.14865C6.25148 6.11038 6.48628 5.94305 6.61006 5.69842L8.2199 2.33521C8.36318 2.04706 8.66025 1.86772 8.98282 1.87523H9.08334C9.36315 1.90899 9.60695 2.08233 9.73223 2.33521Z"
                              fill="url(#paint0_linear_0_7528)"
                            />
                            <path
                              d="M8.99401 14.1878C8.84873 14.1923 8.7072 14.2314 8.5799 14.3012L5.25054 16.0404C4.84317 16.2348 4.35567 16.0839 4.12728 15.6943C4.04266 15.5352 4.01195 15.3528 4.04041 15.1741L4.70538 11.4774C4.75031 11.2086 4.66045 10.9354 4.465 10.7463L1.74595 8.11386C1.4232 7.79785 1.41721 7.27917 1.73322 6.95566C1.73772 6.95115 1.74146 6.9474 1.74595 6.94365C1.87475 6.81604 2.041 6.73197 2.21997 6.7057L5.97392 6.15325C6.24575 6.11872 6.48164 5.94908 6.60145 5.70288L8.23318 2.29734C8.3882 2.02261 8.68549 1.85898 9 1.87624C8.99401 2.09918 8.99401 14.0362 8.99401 14.1878Z"
                              fill="url(#paint1_linear_0_7528)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_7528"
                                x1="9"
                                y1="1.875"
                                x2="9"
                                y2="16.125"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_7528"
                                x1="5.25"
                                y1="1.875"
                                x2="5.25"
                                y2="16.125"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M9.73223 2.33521L11.4021 5.69092C11.5251 5.93404 11.7599 6.10288 12.0307 6.1404L15.7815 6.68667C16.0006 6.71744 16.1994 6.833 16.3336 7.00934C16.4664 7.18343 16.5234 7.40404 16.4912 7.6209C16.4649 7.80099 16.3802 7.96757 16.2504 8.09514L13.5325 10.7297C13.3337 10.9136 13.2437 11.186 13.2917 11.4523L13.9609 15.1562C14.0321 15.6035 13.7358 16.0252 13.2917 16.11C13.1087 16.1392 12.9212 16.1085 12.7561 16.0244L9.41041 14.2813C9.1621 14.156 8.86879 14.156 8.62049 14.2813L5.27477 16.0244C4.86368 16.2428 4.35432 16.0942 4.12552 15.689C4.04075 15.5277 4.01075 15.3438 4.0385 15.1645L4.70765 11.4599C4.75566 11.1942 4.66489 10.9203 4.46685 10.7365L1.74901 8.10339C1.42569 7.79123 1.41594 7.27722 1.72726 6.95381C1.73401 6.94706 1.74151 6.93955 1.74901 6.93205C1.87804 6.80073 2.04758 6.71744 2.23062 6.69568L5.98142 6.14865C6.25148 6.11038 6.48628 5.94305 6.61006 5.69842L8.2199 2.33521C8.36318 2.04706 8.66025 1.86772 8.98282 1.87523H9.08334C9.36315 1.90899 9.60695 2.08233 9.73223 2.33521Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M8.99401 14.1878C8.84873 14.1923 8.7072 14.2314 8.5799 14.3012L5.25054 16.0404C4.84317 16.2348 4.35567 16.0839 4.12728 15.6943C4.04266 15.5352 4.01195 15.3528 4.04041 15.1741L4.70538 11.4774C4.75031 11.2086 4.66045 10.9354 4.465 10.7463L1.74595 8.11386C1.4232 7.79785 1.41721 7.27917 1.73322 6.95566C1.73772 6.95115 1.74146 6.9474 1.74595 6.94365C1.87475 6.81604 2.041 6.73197 2.21997 6.7057L5.97392 6.15325C6.24575 6.11872 6.48164 5.94908 6.60145 5.70288L8.23318 2.29734C8.3882 2.02261 8.68549 1.85898 9 1.87624C8.99401 2.09918 8.99401 14.0362 8.99401 14.1878Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Secondary Planet
                    </NavLink>
                  </li>}

                  {useCheckPermission("manageTutorial", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/manage-tutorial"
                      className={`${styles.navLink} ${pageActive === "manage-tutorial" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "manage-tutorial" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="16"
                            viewBox="0 0 14 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.1066 5.76575C11.768 5.76575 11.3194 5.75825 10.761 5.75825C9.39903 5.75825 8.27916 4.631 8.27916 3.25625V0.84425C8.27916 0.6545 8.12766 0.5 7.93978 0.5H3.97272C2.12137 0.5 0.625 2.0195 0.625 3.88175V11.963C0.625 13.9167 2.19267 15.5 4.12718 15.5H10.0347C11.8794 15.5 13.375 13.9902 13.375 12.1265V6.10325C13.375 5.91275 13.2242 5.759 13.0356 5.75975C12.7185 5.762 12.3383 5.76575 12.1066 5.76575Z"
                              fill="url(#paint0_linear_0_8426)"
                            />
                            <path
                              opacity="0.4"
                              d="M10.063 0.925527C9.83877 0.692277 9.44727 0.852777 9.44727 1.17603V3.15378C9.44727 3.98328 10.1305 4.66578 10.96 4.66578C11.4828 4.67178 12.2088 4.67328 12.8253 4.67178C13.141 4.67103 13.3015 4.29378 13.0825 4.06578C12.2913 3.24303 10.8745 1.76853 10.063 0.925527Z"
                              fill="url(#paint1_linear_0_8426)"
                            />
                            <path
                              d="M8.81344 10.1695C9.12169 10.1695 9.37219 10.42 9.37219 10.7282C9.37219 11.0365 9.12169 11.2862 8.81344 11.2862H4.73044C4.42219 11.2862 4.17244 11.0365 4.17244 10.7282C4.17244 10.42 4.42219 10.1695 4.73044 10.1695H8.81344ZM7.26911 6.42383C7.57736 6.42383 7.82786 6.67433 7.82786 6.98258C7.82786 7.29083 7.57736 7.54058 7.26911 7.54058H4.73036C4.42211 7.54058 4.17236 7.29083 4.17236 6.98258C4.17236 6.67433 4.42211 6.42383 4.73036 6.42383H7.26911Z"
                              fill="url(#paint2_linear_0_8426)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_8426"
                                x1="7"
                                y1="0.5"
                                x2="7"
                                y2="15.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_8426"
                                x1="11.3154"
                                y1="0.814941"
                                x2="11.3154"
                                y2="4.67232"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint2_linear_0_8426"
                                x1="6.77228"
                                y1="6.42383"
                                x2="6.77228"
                                y2="11.2862"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="16"
                            viewBox="0 0 14 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.1066 5.76575C11.768 5.76575 11.3194 5.75825 10.761 5.75825C9.39903 5.75825 8.27916 4.631 8.27916 3.25625V0.84425C8.27916 0.6545 8.12766 0.5 7.93978 0.5H3.97272C2.12137 0.5 0.625 2.0195 0.625 3.88175V11.963C0.625 13.9167 2.19267 15.5 4.12718 15.5H10.0347C11.8794 15.5 13.375 13.9902 13.375 12.1265V6.10325C13.375 5.91275 13.2242 5.759 13.0356 5.75975C12.7185 5.762 12.3383 5.76575 12.1066 5.76575Z"
                              fill="#7D96B3"
                            />
                            <path
                              opacity="0.4"
                              d="M10.063 0.925527C9.83877 0.692277 9.44727 0.852777 9.44727 1.17603V3.15378C9.44727 3.98328 10.1305 4.66578 10.96 4.66578C11.4828 4.67178 12.2088 4.67328 12.8253 4.67178C13.141 4.67103 13.3015 4.29378 13.0825 4.06578C12.2913 3.24303 10.8745 1.76853 10.063 0.925527Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M8.81344 10.1696C9.12169 10.1696 9.37219 10.4201 9.37219 10.7284C9.37219 11.0366 9.12169 11.2863 8.81344 11.2863H4.73044C4.42219 11.2863 4.17244 11.0366 4.17244 10.7284C4.17244 10.4201 4.42219 10.1696 4.73044 10.1696H8.81344ZM7.26911 6.42395C7.57736 6.42395 7.82786 6.67445 7.82786 6.9827C7.82786 7.29095 7.57736 7.5407 7.26911 7.5407H4.73036C4.42211 7.5407 4.17236 7.29095 4.17236 6.9827C4.17236 6.67445 4.42211 6.42395 4.73036 6.42395H7.26911Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Manage Tutorial
                    </NavLink>
                  </li>}

                  {useCheckPermission("accounting", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/accounting"
                      className={`${styles.navLink} ${pageActive === "accounting" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "accounting" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="14"
                            viewBox="0 0 16 14"
                            fill="none"
                          >
                            <path
                              d="M11.3853 0.25C13.97 0.25 15.4973 1.73397 15.4973 4.25339V4.28134H12.3213C10.8433 4.28394 9.646 5.45136 9.64333 6.89242C9.64133 8.33674 10.84 9.50935 12.3213 9.5113H15.5V9.74076C15.5 12.2602 13.9727 13.75 11.388 13.75H4.61267C2.02733 13.75 0.5 12.2602 0.5 9.74076V4.25339C0.5 1.73397 2.02733 0.25 4.61267 0.25H11.3853ZM8.28733 3.15618H4.05467C3.74 3.15748 3.48467 3.40644 3.48333 3.71389C3.482 4.02264 3.738 4.27419 4.05467 4.27549H8.29267C8.60933 4.27419 8.86533 4.02264 8.86401 3.71324C8.86267 3.40449 8.604 3.15488 8.28733 3.15618Z"
                              fill="url(#paint0_linear_0_9207)"
                            />
                            <path
                              opacity="0.4"
                              d="M11.0281 7.22255C11.1849 7.93594 11.8104 8.43785 12.5244 8.4248H14.9619C15.259 8.4248 15.5 8.17874 15.5 7.87458V5.97592C15.4994 5.67242 15.259 5.4257 14.9619 5.42505H12.4671C11.6548 5.42766 10.9987 6.10189 11 6.93276C11 7.03001 11.0096 7.12726 11.0281 7.22255Z"
                              fill="url(#paint1_linear_0_9207)"
                            />
                            <path
                              d="M12.5 7.67505C12.9142 7.67505 13.25 7.33926 13.25 6.92505C13.25 6.51083 12.9142 6.17505 12.5 6.17505C12.0858 6.17505 11.75 6.51083 11.75 6.92505C11.75 7.33926 12.0858 7.67505 12.5 7.67505Z"
                              fill="url(#paint2_linear_0_9207)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_9207"
                                x1="8"
                                y1="0.25"
                                x2="8"
                                y2="13.75"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_9207"
                                x1="13.25"
                                y1="5.42505"
                                x2="13.25"
                                y2="8.42505"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint2_linear_0_9207"
                                x1="12.5"
                                y1="6.17505"
                                x2="12.5"
                                y2="7.67505"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="14"
                            viewBox="0 0 16 14"
                            fill="none"
                          >
                            <path
                              d="M11.3853 0.25C13.97 0.25 15.4973 1.73397 15.4973 4.25339V4.28134H12.3213C10.8433 4.28394 9.646 5.45136 9.64333 6.89242C9.64133 8.33674 10.84 9.50935 12.3213 9.5113H15.5V9.74076C15.5 12.2602 13.9727 13.75 11.388 13.75H4.61267C2.02733 13.75 0.5 12.2602 0.5 9.74076V4.25339C0.5 1.73397 2.02733 0.25 4.61267 0.25H11.3853ZM8.28733 3.15618H4.05467C3.74 3.15748 3.48467 3.40644 3.48333 3.71389C3.482 4.02264 3.738 4.27419 4.05467 4.27549H8.29267C8.60933 4.27419 8.86533 4.02264 8.86401 3.71324C8.86267 3.40449 8.604 3.15488 8.28733 3.15618Z"
                              fill="#7D96B3"
                            />
                            <path
                              opacity="0.4"
                              d="M11.0281 7.22255C11.1849 7.93594 11.8104 8.43785 12.5244 8.4248H14.9619C15.259 8.4248 15.5 8.17874 15.5 7.87458V5.97592C15.4994 5.67242 15.259 5.4257 14.9619 5.42505H12.4671C11.6548 5.42766 10.9987 6.10189 11 6.93276C11 7.03001 11.0096 7.12726 11.0281 7.22255Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M12.5 7.67505C12.9142 7.67505 13.25 7.33926 13.25 6.92505C13.25 6.51083 12.9142 6.17505 12.5 6.17505C12.0858 6.17505 11.75 6.51083 11.75 6.92505C11.75 7.33926 12.0858 7.67505 12.5 7.67505Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Accounting
                    </NavLink>
                  </li>}

                  {useCheckPermission("subAdmin", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/manage-users"
                      className={`${styles.navLink} ${pageActive === "manage-users" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "manage-users" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M15.8258 7.1909H14.9235V6.30871C14.9235 5.93208 14.6214 5.625 14.2492 5.625C13.8778 5.625 13.575 5.93208 13.575 6.30871V7.1909H12.6742C12.3021 7.1909 12 7.49798 12 7.87461C12 8.25124 12.3021 8.55832 12.6742 8.55832H13.575V9.44129C13.575 9.81792 13.8778 10.125 14.2492 10.125C14.6214 10.125 14.9235 9.81792 14.9235 9.44129V8.55832H15.8258C16.1972 8.55832 16.5 8.25124 16.5 7.87461C16.5 7.49798 16.1972 7.1909 15.8258 7.1909Z"
                              fill="url(#paint0_linear_0_11303)"
                            />
                            <path
                              d="M7.125 11.2617C4.09067 11.2617 1.5 11.7468 1.5 13.685C1.5 15.6225 4.0749 16.1251 7.125 16.1251C10.1586 16.1251 12.75 15.64 12.75 13.7018C12.75 11.7636 10.1751 11.2617 7.125 11.2617Z"
                              fill="url(#paint1_linear_0_11303)"
                            />
                            <path
                              opacity="0.4"
                              d="M7.12505 9.41566C9.19098 9.41566 10.847 7.73827 10.847 5.64571C10.847 3.55315 9.19098 1.875 7.12505 1.875C5.05912 1.875 3.40308 3.55315 3.40308 5.64571C3.40308 7.73827 5.05912 9.41566 7.12505 9.41566Z"
                              fill="url(#paint2_linear_0_11303)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_11303"
                                x1="14.25"
                                y1="5.625"
                                x2="14.25"
                                y2="10.125"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_11303"
                                x1="7.125"
                                y1="11.2617"
                                x2="7.125"
                                y2="16.1251"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint2_linear_0_11303"
                                x1="7.12505"
                                y1="1.875"
                                x2="7.12505"
                                y2="9.41566"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M15.8258 7.1909H14.9235V6.30871C14.9235 5.93208 14.6214 5.625 14.2492 5.625C13.8778 5.625 13.575 5.93208 13.575 6.30871V7.1909H12.6742C12.3021 7.1909 12 7.49798 12 7.87461C12 8.25124 12.3021 8.55832 12.6742 8.55832H13.575V9.44129C13.575 9.81792 13.8778 10.125 14.2492 10.125C14.6214 10.125 14.9235 9.81792 14.9235 9.44129V8.55832H15.8258C16.1972 8.55832 16.5 8.25124 16.5 7.87461C16.5 7.49798 16.1972 7.1909 15.8258 7.1909Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M7.125 11.2617C4.09067 11.2617 1.5 11.7468 1.5 13.685C1.5 15.6225 4.0749 16.1251 7.125 16.1251C10.1586 16.1251 12.75 15.64 12.75 13.7018C12.75 11.7636 10.1751 11.2617 7.125 11.2617Z"
                              fill="#7D96B3"
                            />
                            <path
                              opacity="0.4"
                              d="M7.12505 9.41566C9.19098 9.41566 10.847 7.73827 10.847 5.64571C10.847 3.55315 9.19098 1.875 7.12505 1.875C5.05912 1.875 3.40308 3.55315 3.40308 5.64571C3.40308 7.73827 5.05912 9.41566 7.12505 9.41566Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Manage Users
                    </NavLink>
                  </li>}

                  {useCheckPermission("faq", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/faq-management"
                      className={`${styles.navLink} ${pageActive === "faq-management" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "faq-management" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M11.5 0.5H4.5C1.94667 0.5 0.5 1.94667 0.5 4.5V11.5C0.5 14.0467 1.94 15.5 4.5 15.5H11.5C14.0533 15.5 15.5 14.0467 15.5 11.5V4.5C15.5 1.94667 14.0533 0.5 11.5 0.5Z"
                              fill="url(#paint0_linear_0_12538)"
                            />
                            <path
                              d="M10.4903 8.53125H8.56214V10.4427C8.56214 10.7505 8.31046 11 8 11C7.68954 11 7.43786 10.7505 7.43786 10.4427V8.53125H5.50966C5.22007 8.50152 5 8.25961 5 7.97099C5 7.68237 5.22007 7.44046 5.50966 7.41073H7.43182V5.50524C7.4618 5.21816 7.70584 5 7.99698 5C8.28812 5 8.53215 5.21816 8.56214 5.50524V7.41073H10.4903C10.7799 7.44046 11 7.68237 11 7.97099C11 8.25961 10.7799 8.50152 10.4903 8.53125Z"
                              fill="url(#paint1_linear_0_12538)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_12538"
                                x1="8"
                                y1="0.5"
                                x2="8"
                                y2="15.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_12538"
                                x1="8"
                                y1="5"
                                x2="8"
                                y2="11"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M15.5 8C15.5 12.143 12.1423 15.5 8 15.5C3.85775 15.5 0.5 12.143 0.5 8C0.5 3.8585 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.8585 15.5 8Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M7.99634 10.1966C8.36609 10.1966 8.66009 10.4913 8.66009 10.8528C8.66009 11.2143 8.36609 11.5091 8.00384 11.5091C7.64009 11.5091 7.34384 11.2143 7.34384 10.8528C7.34384 10.4913 7.63709 10.1966 7.99634 10.1966ZM7.99634 4.50195C8.35784 4.50195 8.65259 4.7967 8.65259 5.1582V8.4732C8.65259 8.8347 8.35784 9.12945 7.99634 9.12945C7.63484 9.12945 7.34009 8.8347 7.34009 8.4732V5.1582C7.34009 4.7967 7.63484 4.50195 7.99634 4.50195Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      FAQ Management
                    </NavLink>
                  </li>}

                  {useCheckPermission("content", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/content-page"
                      className={`${styles.navLink} ${pageActive === "content-page" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "content-page" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M11.5 0.5H4.5C1.94667 0.5 0.5 1.94667 0.5 4.5V11.5C0.5 14.0467 1.94 15.5 4.5 15.5H11.5C14.0533 15.5 15.5 14.0467 15.5 11.5V4.5C15.5 1.94667 14.0533 0.5 11.5 0.5Z"
                              fill="url(#paint0_linear_0_12538)"
                            />
                            <path
                              d="M10.4903 8.53125H8.56214V10.4427C8.56214 10.7505 8.31046 11 8 11C7.68954 11 7.43786 10.7505 7.43786 10.4427V8.53125H5.50966C5.22007 8.50152 5 8.25961 5 7.97099C5 7.68237 5.22007 7.44046 5.50966 7.41073H7.43182V5.50524C7.4618 5.21816 7.70584 5 7.99698 5C8.28812 5 8.53215 5.21816 8.56214 5.50524V7.41073H10.4903C10.7799 7.44046 11 7.68237 11 7.97099C11 8.25961 10.7799 8.50152 10.4903 8.53125Z"
                              fill="url(#paint1_linear_0_12538)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_0_12538"
                                x1="8"
                                y1="0.5"
                                x2="8"
                                y2="15.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_0_12538"
                                x1="8"
                                y1="5"
                                x2="8"
                                y2="11"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.5 1.5H5.5C2.94667 1.5 1.5 2.94667 1.5 5.5V12.5C1.5 15.0467 2.94 16.5 5.5 16.5H12.5C15.0533 16.5 16.5 15.0467 16.5 12.5V5.5C16.5 2.94667 15.0533 1.5 12.5 1.5Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M11.4903 9.53125H9.56214V11.4427C9.56214 11.7505 9.31046 12 9 12C8.68954 12 8.43786 11.7505 8.43786 11.4427V9.53125H6.50966C6.22007 9.50152 6 9.25961 6 8.97099C6 8.68237 6.22007 8.44046 6.50966 8.41073H8.43182V6.50524C8.4618 6.21816 8.70584 6 8.99698 6C9.28812 6 9.53215 6.21816 9.56214 6.50524V8.41073H11.4903C11.7799 8.44046 12 8.68237 12 8.97099C12 9.25961 11.7799 9.50152 11.4903 9.53125Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Content Page
                    </NavLink>
                  </li>}

                  {useCheckPermission("timezone", "VIEW") && <li className="py-1">
                    <NavLink
                      to="/timezone"
                      className={`${styles.navLink} ${pageActive === "timezone" ? styles.active : ""
                        } d-flex align-items-center navLink py-2 px-3 position-relative`}
                    >
                      <span className="icn me-2">
                        {pageActive === "timezone" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M11.5 0.5H4.5C1.94667 0.5 0.5 1.94667 0.5 4.5V11.5C0.5 14.0467 1.94 15.5 4.5 15.5H11.5C14.0533 15.5 15.5 14.0467 15.5 11.5V4.5C15.5 1.94667 14.0533 0.5 11.5 0.5Z"
                              fill="url(#paint0_linear_25_814)"
                            />
                            <path
                              d="M10.9996 9.15625C10.9996 10.7271 9.65693 12 7.99982 12C6.34271 12 5 10.7271 5 9.15625C5 7.73438 6.10041 6.55586 7.53831 6.34668V5.875H7.13449C7.0393 5.875 6.96142 5.80117 6.96142 5.71094V5.16406C6.96142 5.07383 7.0393 5 7.13449 5H8.86515C8.96034 5 9.03822 5.07383 9.03822 5.16406V5.71094C9.03822 5.80117 8.96034 5.875 8.86515 5.875H8.46133V6.34668C9.00216 6.42598 9.4954 6.64199 9.89922 6.95645L10.2958 6.58047C10.3636 6.51621 10.4732 6.51621 10.541 6.58047L10.9492 6.96738C11.0169 7.03164 11.0169 7.13555 10.9492 7.1998L10.5251 7.60176L10.5165 7.60996C10.8222 8.05293 10.9996 8.58477 10.9996 9.15625ZM8.46133 9.64844V7.57715C8.46133 7.48691 8.38345 7.41309 8.28826 7.41309H7.71138C7.61619 7.41309 7.53831 7.48691 7.53831 7.57715V9.64844C7.53831 9.73867 7.61619 9.8125 7.71138 9.8125H8.28826C8.38345 9.8125 8.46133 9.73867 8.46133 9.64844Z"
                              fill="#275538"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_25_814"
                                x1="8"
                                y1="0.5"
                                x2="8"
                                y2="15.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M12.5 1.5H5.5C2.94667 1.5 1.5 2.94667 1.5 5.5V12.5C1.5 15.0467 2.94 16.5 5.5 16.5H12.5C15.0533 16.5 16.5 15.0467 16.5 12.5V5.5C16.5 2.94667 15.0533 1.5 12.5 1.5Z"
                              fill="#7D96B3"
                            />
                            <path
                              d="M12.4996 10.1562C12.4996 11.7271 11.1569 13 9.49982 13C7.84271 13 6.5 11.7271 6.5 10.1562C6.5 8.73438 7.60041 7.55586 9.03831 7.34668V6.875H8.63449C8.5393 6.875 8.46142 6.80117 8.46142 6.71094V6.16406C8.46142 6.07383 8.5393 6 8.63449 6H10.3652C10.4603 6 10.5382 6.07383 10.5382 6.16406V6.71094C10.5382 6.80117 10.4603 6.875 10.3652 6.875H9.96133V7.34668C10.5022 7.42598 10.9954 7.64199 11.3992 7.95645L11.7958 7.58047C11.8636 7.51621 11.9732 7.51621 12.041 7.58047L12.4492 7.96738C12.5169 8.03164 12.5169 8.13555 12.4492 8.1998L12.0251 8.60176L12.0165 8.60996C12.3222 9.05293 12.4996 9.58477 12.4996 10.1562ZM9.96133 10.6484V8.57715C9.96133 8.48691 9.88345 8.41309 9.78826 8.41309H9.21138C9.11619 8.41309 9.03831 8.48691 9.03831 8.57715V10.6484C9.03831 10.7387 9.11619 10.8125 9.21138 10.8125H9.78826C9.88345 10.8125 9.96133 10.7387 9.96133 10.6484Z"
                              fill="#7D96B3"
                            />
                          </svg>
                        )}
                      </span>
                      Time Zone
                    </NavLink>
                  </li>}
                </ul>
              </div>
            </div>
            <div className="bottom w-100">
              <div className="py-2">
                <div className={`${styles.logout} logout text-center`}>
                  <Button
                    onClick={handleLogout}
                    className="rounded-pill p-1 d-inline-flex align-items-center justify-content-center pe-3"
                  >
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <circle cx="13" cy="13" r="13" fill="white" />
                        <path
                          d="M17.9708 7.28859L17.9708 7.28859L17.9689 7.28641C17.5675 6.83279 16.9041 6.75812 16.4355 7.09539L16.4351 7.09572C15.937 7.45316 15.768 8.11666 16.0466 8.66837L16.048 8.6711C16.1099 8.79596 16.2099 8.92301 16.3295 9.04248L16.3312 9.04426C17.7677 10.4982 18.3446 12.2735 17.8341 14.3294L17.8341 14.3295C17.3466 16.2894 16.0916 17.5916 14.2444 18.1773L14.2439 18.1775C12.4432 18.7457 10.7473 18.3827 9.29385 17.1611C8.04104 16.1106 7.39943 14.6968 7.37738 13.0317C7.35838 11.7029 7.8042 10.528 8.62331 9.5252C8.69458 9.43739 8.77424 9.36624 8.83162 9.31544C8.83664 9.31099 8.8415 9.30669 8.84621 9.30253C8.90256 9.25268 8.93761 9.22167 8.96795 9.1882L8.96793 9.18818L8.97093 9.18495C9.3007 8.82898 9.38902 8.42543 9.24507 7.95198C9.09942 7.48526 8.79129 7.22026 8.32751 7.12616C7.98891 7.05821 7.68268 7.14281 7.38088 7.38516L7.37967 7.38612C6.77746 7.8659 6.35485 8.51596 5.96088 9.25146C5.29886 10.4885 5.00042 11.824 5.04793 13.2448L5.04794 13.2453C5.10383 14.9779 5.65228 16.5167 6.68685 17.8675C7.66908 19.1469 8.89547 20.0439 10.3793 20.4968L10.3796 20.4969C12.912 21.2721 15.2522 20.8673 17.372 19.2076L17.3722 19.2075C18.7442 18.1347 19.6461 16.7092 20.094 14.9676L20.0945 14.9658C20.2628 14.3235 20.3359 13.6622 20.339 12.9821C20.3074 10.8173 19.5663 8.97535 18.1076 7.44387L18.3972 7.168L18.1084 7.4447C18.077 7.41197 18.0257 7.35224 17.9948 7.31625C17.9833 7.30291 17.9747 7.29283 17.9708 7.28859Z"
                          fill="#EB5757"
                          stroke="white"
                          strokeWidth="0.8"
                        />
                        <path
                          d="M11.1115 10.6564C11.1144 11.4968 11.7262 12.1935 12.5224 12.273C13.3478 12.3585 14.0855 11.8024 14.2494 10.9651C14.2728 10.8459 14.2758 10.7237 14.2758 10.6014M11.1115 10.6564C11.1056 8.39514 11.1056 7.60051 11.1115 5.33921C11.1115 4.73722 11.3837 4.26968 11.8725 3.9641C12.3819 3.64324 12.9263 3.63102 13.4474 3.93049C13.9801 4.23607 14.267 4.72194 14.2699 5.36366M11.1115 10.6564L11.5114 10.6554C11.5114 10.6554 11.5114 10.6553 11.5114 10.6553C11.5138 11.3043 11.9833 11.8172 12.5621 11.8749L12.5636 11.8751C13.1758 11.9385 13.7313 11.5298 13.8569 10.8882L13.8569 10.8879C13.8722 10.8101 13.8757 10.7218 13.8758 10.6025M11.1115 10.6564L11.5114 10.655L13.8758 10.6025M14.2699 5.36366C14.2718 6.08143 14.2713 6.50107 14.2706 7.00316C14.2703 7.28769 14.2699 7.5987 14.2699 8.00546V8.00552C14.2699 9.11473 14.2699 9.49219 14.2758 10.6014M14.2699 5.36366L13.8699 5.36548C13.8699 5.36536 13.8699 5.36524 13.8699 5.36512M14.2699 5.36366L13.8699 5.3647C13.8699 5.36484 13.8699 5.36498 13.8699 5.36512M14.2758 10.6014L13.8758 10.6035C13.8758 10.6032 13.8758 10.6028 13.8758 10.6025M14.2758 10.6014H13.8758C13.8758 10.6018 13.8758 10.6021 13.8758 10.6025M13.8758 10.6025C13.8699 9.49303 13.8699 9.11466 13.8699 8.00546C13.8699 7.59767 13.8703 7.28635 13.8706 7.00178C13.8713 6.50037 13.8718 6.08197 13.8699 5.36512M13.8758 10.6025L11.5114 5.34025L11.5115 5.33921C11.5115 4.87817 11.71 4.5374 12.0845 4.30329L12.0857 4.30255L12.0857 4.30255C12.4704 4.0602 12.8562 4.05207 13.248 4.27729L13.2483 4.27746C13.6556 4.51105 13.8675 4.86432 13.8699 5.36512"
                          fill="#EB5757"
                          stroke="white"
                          strokeWidth="0.8"
                        />
                      </svg>
                    </span>
                    Log Out
                  </Button>
                </div>
              </div>
            </div>
          </Accordion>
        </>
      )}
    </div>
  );
};

export default Sidebar;
